module.exports = __webpack_public_path__ + "img/2.f7f99ebb.jpg";